import { useElasticData } from "../DataContext.js";

const NotesPanel = ({tabIndex, sel}) => {
        
    let { productData } = useElasticData();
    const name = `tab-${tabIndex}`;

    return(
        <div id={`tab-${tabIndex}`} className={`tabContent ${name == sel ? "current" : ""}`}>
            <textarea id="myNotesInput" defaultValue={productData ? productData.bookNotes : ""} />
            <div className="row endAlign">
                <span className="bookNotesLastEdited">{ productData.bookNotesLastEdited ? `Last edited: ${new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium', timeStyle: 'medium' }).format(new Date(productData.bookNotesLastEdited))}` : "No history" }</span>
                <button id="myNotesSave" type="button" className="button">Save changes</button>
            </div>
        </div>
    )
}

export default NotesPanel;